<!--Component of Create/Edit Lead Individual-->
<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <span><router-link to="/listleads" class="text-white pl-2 text-line">Leads</router-link></span>
                            <div>{{ $route.params.id == 'new' ? 'Create Leads' : 'Edit Leads'}}</div>
                        </div>
                    </div>
                </div>
            </h2>
            <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else class="start-overflow">
                <div class="create-company-container w-100 ">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-3 text-white ml-3 ">Lead Information</span>
                            <span class="pointer mt-2 " @click="showHideLeadInfo">
                                <i v-if="leadInfoTab" class="icon-chevron-double-up text-white"
                                    style="font-size: 20px"></i>
                                <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px;"></i>
                            </span>
                        </div>
                    </div>
                    <div v-if="leadInfoTab">
                        <div class="col-lg-4 col-md-6 col-sm-12 mt-4 mt-3">
                            <span class="input-label ml-4 ">Select Lead as Individual or Company</span>
                            <div class="d-flex align-items-center ml-6 mt-6">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="text-secondary fs-14 fw-600 mr-2">Individual</span>
                                    <div class="form-check form-check-inline mr-7">
                                        <label class="form-check-label check-label-dc">
                                            <input class="form-check-input"  type="radio" value="Individual" name="individual" @change="changeLead(selected_lead)" v-model="selected_lead" />
                                            <span class="radio-icon"></span>
                                        </label>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="text-secondary fs-14 fw-600 mr-2">Company</span>
                                    <div class="form-check form-check-inline mr-7">
                                        <label class="form-check-label check-label-dc">
                                            <input class="form-check-input"  type="radio" value="Company" name="company" @change="changeLead(selected_lead)" v-model="selected_lead" />
                                            <span class="radio-icon"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-6 pl-10 pr-2">
                            <div class="row">
                                <div class="col-lg-4 col-md-12 col-sm-12 mt-4" >
                                    <div class="w-100">
                                        <span class="input-label">Company Name <sup class="ml-02 fs-14 text-danger">*</sup></span>
                                        <div class="d-flex align-content-center mt-2">
                                            <input type="text" maxlength="30" class="input-field input-width"
                                                v-model="company_name" v-validate="{required:true}" autocomplete="off"
                                                placeholder="Enter Company Name" name="company_name" />

                                        </div>
                                        <div class="text-right">
                                            <span class="float-left text-danger mb-3"
                                                v-show="errors.has('company_name')">Company Name is required
                                            </span>
                                            <span class="input-field-length float-right">{{ company_name.length }}/30</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-12 col-sm-12 mt-4" >
                                    <div class="w-100">
                                        <span class="input-label">Company Email <sup class="ml-02 fs-14 text-danger">*</sup></span>
                                        <div class="d-flex align-content-center mt-2">
                                            <input type="email" class="input-field input-width" maxlength="100"
                                                v-model="company_email" v-validate="{required: true, email: true}"
                                                autocomplete="off" placeholder="Enter Company Email" name="company_email" />
                                        </div>
                                        <span class="invalid-feedback-form float-left text-danger"
                                            style="text-transform: none !important;width: 80%;margin-top: 0px;"
                                            v-show="errors.has('company_email')">{{errors.first('company_email')}}
                                        </span>
                                        <span class="input-field-length float-right">{{ company_email.length }}/100</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100 pr-8">
                                        <span class="input-label">Campaign Source</span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                :loading="load_campaign"
                                                name="campaign_source_type" label="value" v-model="campaign_source"
                                                :multiple="false" :options="source_type_options" @search-change="SearchCampaignSource"
                                                @open="loadLeadsSettings('campaign_source')" :show-labels="false"
                                                placeholder="Select Campaign Source">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Campagian Source is not
                                                        found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span class="pointer mt-1" @click="redirectSettings">
                                                <el-tooltip class="item" effect="dark"
                                                    content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                    placement="top">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                        class="ml-2 " style="width:25px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                        <!-- <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('campaign_source_type')"
                                                style="text-transform: none !important;">Campagin Source is
                                                required</span>
                                        </div> -->
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="input-label">Assigned by</span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect @close="resetEmployees" label="full_name"
                                                name="assigned_by_type" v-model="assigned_by" :loading="load_assigned_by"
                                                @search-change="searchAssigned($event,'assigned_by')" :internal-search="false"
                                                @open="fetchAssigned('','assigned_by')" :searchable="true"
                                                :options="assigned_to_type"
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                placeholder="Select Assigned By">
                                                <div class="add-vendor fw-500">Assigned By <sup class="fs-14 ml-02">*</sup>
                                                    <span class="text-secondary fw-500">'{{assigned_by}}'</span>
                                                    <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                </div>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfEmployees" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Assigned By
                                                        is
                                                        not found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span>
                                                <i class="icon icon-check-circle fs-30 ml-2" style="color: #ff9a06;"></i>
                                            </span>
                                        </div>
                                        <!-- <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('assigned_by_type')"
                                                style="text-transform: none !important;">Assigned by is
                                                required</span>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="input-label">Assigned to
                                        </span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect name="assigned_to_type" label="full_name"
                                                v-model="assigned_to" @close="resetEmployees" :loading="load_assigned_to"
                                                @search-change="searchAssigned($event,'assigned')" @open="fetchAssigned(null,'assigned')"
                                                :searchable="true" :internal-search="false"
                                                :options="assigned_to_type"
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                placeholder="Select Assigned To">
                                                <div class="add-vendor fw-500">Assigned To
                                                    <span class="text-secondary fw-500">'{{add_assigned_to}}'</span>
                                                    <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                </div>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfEmployees" />
                                                </template>
                                                <!--<template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">Assigned To
                                                        is
                                                        not found</div>
                                                </template>-->
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span>
                                                <i class="icon icon-check-circle fs-30 ml-2" style="color: #ff9a06;"></i>
                                            </span>
                                        </div>
                                        <!-- <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('assigned_to_type')"
                                                style="text-transform: none !important;">Assigned by is
                                                required</span>
                                        </div> -->
                                    </div>
                                </div>
                            <!-- </div>
                            <div class="row"> -->
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="input-label">Lead Type <sup class="ml-02 fs-14 text-danger">*</sup></span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect v-validate="'required'"
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                :loading="load_lead_type" @search-change="searchLeadsType" :searchable="true"
                                                :options="lead_type_options" name="leads_type" v-model="lead_type"
                                                placeholder="Select Lead Type">
                                                <div class="add-vendor fw-500">
                                                    Add Lead Type
                                                    <span class="text-secondary fw-500">'{{add_leads_type}}'</span>
                                                    <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                </div>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">
                                                        Lead type is not found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No
                                                        Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span class="pointer mt-2">
                                                <el-tooltip class="item" effect="dark"
                                                    content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                    placement="top">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                        class="ml-2 v-hidden" style="width:25px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                        <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('leads_type')"
                                                style="text-transform: none !important;">Lead Type is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="input-label">Qualifying Lead Template<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect v-validate="'required'"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                            name="qualifying_lead" :searchable="true" @search-change="loadQualifyingLeadList"
                                            :loading="qualifying_lead_loading" v-model="qualifying_lead"
                                            :max-height="200" label="qualifying_lead_name" @select="getSelectedTemplateData($event)"
                                            :options="qualifying_lead_options" placeholder="Select Qualifying Lead">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-left fw-600">No Results Found</div>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfQualifyingLead" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-left fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('qualifying_lead')"
                                                style="text-transform: none !important;">Qualifying Lead Template is required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="input-label">Industry Type <span class="text-danger">*</span></span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                :loading="load_industry" @search-change="searchIndustryType"
                                                :searchable="true" @select="enableSave()" :options="industry_type_options" name="industry_type"
                                                v-model="industry_type"  placeholder="Select Industry" v-validate="{ required: this.IndustryValidate }">

                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">
                                                        Industry Type is not found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No
                                                        Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span class="pointer " @click="redirectSettings">
                                                <el-tooltip class="item" effect="dark"
                                                    content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                    placement="top">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                        class="ml-2 " style="width:25px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                        <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left"  v-show="errors.has('industry_type')"
                                                style="text-transform: none !important;"> Industry Type is required</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100 pr-8">
                                        <span class="input-label">Lead Source (Channel)</span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <multiselect
                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                name="lead_source_type" :searchable="true" :options="lead_source_options"
                                                v-model="lead_source" @change="changeLead(lead_source)"
                                                placeholder="Select Lead Source">

                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">
                                                        Lead Source is not found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No
                                                        Results Found
                                                    </div>
                                                </template>
                                            </multiselect>

                                        </div>
                                        <!-- <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('lead_source_type')"
                                                style="text-transform: none !important;">Lead Source is
                                                required</span>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-2 col-md-6 col-sm-12 mt-3 "
                                    :class="{'pointer-event': $route.params.id != 'new'}">
                                    <div class="w-100 mt-1">
                                        <span class="input-label">Date</span>
                                        <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                            <date-picker
                                                class="cal-icon profile-date-picker date-input-customer  calendar-edit-per input-field pt-0 pb-0 pr-0"
                                                v-model="formatted_date" value-type="format" lang="en"
                                                type="date" format="YYYY-MM-DD"></date-picker>

                                            <span>
                                                <i class="icon icon-check-circle fs-30 ml-2" style="color: #ff9a06;"
                                                    :class="{'text-green': $route.params.id != 'new'}"></i>
                                            </span>
                                        </div>
                                        <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('date')"
                                                style="text-transform: none !important;">Date is
                                                required</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-6 col-sm-12 mt-3 pl-0"
                                    :class="{'pointer-event': $route.params.id != 'new'}">
                                    <div class="w-100 mt-1">
                                        <span class="input-label">Time
                                            <el-tooltip class="item" effect="dark" content="Default System Time Zone is applied.
                                                Time Zone: (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
                                                placement="top">
                                                <sup class="pl-1 fs-14 ml-02"><i class="icon-information text-secondary"
                                                        style="font-size: 15px;"></i></sup>
                                            </el-tooltip>
                                        </span>
                                        <div class="d-flex align-items-center mt-2">
                                            <date-picker value-type="format"
                                                class=" mx-left  meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                format="HH:mm" type="time" placeholder="HH:MM" lang="en"
                                                :clearable="false" :editable="false" v-model="lead_start_time"
                                                :minute-step="1" confirm confirm-text="APPLY"></date-picker>
                                            <!--date-picker v-else valueType="date2value"
                                                class="mx-left meetinfdatetime time-height-customer calendar-down-arrow-grey"
                                                format="HH:mm" type="time" placeholder="HH:MM"
                                                lang="en" :clearable="false" :editable="false" v-model="lead_start_time"
                                                :minute-step="1" confirm confirm-text="APPLY"></!--date-picker-->
                                            <span>
                                                <i class="icon icon-check-circle fs-30 ml-2" style="color: #ff9a06;"
                                                    :class="{'text-green': $route.params.id != 'new'}"></i>
                                            </span>
                                        </div>
                                        <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('description')"
                                                style="text-transform: none !important;">Date and Time is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Territory</span>
                                        <div class="d-flex align-items-center">
                                            <multiselect label="name" size='8' @search-change="searchTerritory" @open="fetchTerritory" track-by="id" :loading="territory_loading" :limit="1"  :limit-text="limitTerritory" v-model="territory" :blockKeys="['Delete']" @remove="removeTerritory" placeholder="Select Territory" class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2" id="ajaxgb" :options="territory_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center font-weight-bold" >Territories Not Found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfTerritories" />
                                                </template>
                                            </multiselect>
                                            <span class="pointer mt-2" @click="changeView()">
                                                <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2" style="width:25px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
                                    <div class="w-100">
                                        <span class="input-label">Description</span>
                                        <div class="d-flex align-content-center" style="margin-top: 7px;">
                                            <input type="text" class="input-field input-width" v-model="description" maxlength="200"
                                                placeholder="Enter Description" name="description" />
                                            <span class="pointer mt-2">
                                                <el-tooltip class="item" effect="dark"
                                                    content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                    placement="top">
                                                    <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                        class="ml-2 v-hidden" style="width:25px" alt="">
                                                </el-tooltip>
                                            </span>
                                        </div>
                                        <div class="text-right" style="padding-right: 32px;">
                                            <span class="text-danger float-left" v-show="errors.has('description')"
                                                style="text-transform: none !important;">Description is
                                                required</span>
                                            <span class="input-field-length float-right">{{ description.length }}/200</span>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!--Start Point of Contact-->
                        <div  class="create-company-container w-100">
                            <div class="mt-6 pl-10 pr-2">
                                <div class="pr-8">
                                    <div class="create-company-header d-flex align-items-center justify-content-between ">
                                        <span class="fs-14 text-white">
                                            Point of Contact
                                        </span>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mt-1">
                                        <div class="w-100">
                                            <span class="input-label">Title</span>
                                            <div class="d-flex align-content-center" style="margin-top:11px;">
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                    name="lead_title" v-model="lead_title" :loading="load_title"
                                                    @search-change="searchTitle" :searchable="true" :options="leads_title_options"
                                                    placeholder="--Select--">
                                                    <div class="add-vendor fw-500">Lead Title
                                                        <span class="text-secondary fw-500">'{{add_title}}'</span>
                                                        <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                    </div>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">Title
                                                            is
                                                            not found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No Results Found
                                                        </div>
                                                    </template>
                                                </multiselect>
                                                <span class="pointer mt-2" @click="redirectSettings">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                        placement="top">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                            class="ml-2 " style="width:25px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <!--div class="text-right" style="padding-right: 32px;">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('lead_title')">Lead
                                                    Title is required
                                                </span>
                                            </div-->
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 mt-1">
                                        <div class="w-100">
                                            <span class="input-label">Lead First Name
                                            </span>
                                            <div class="d-flex align-content-center mt-3">
                                                <input type="text" class="input-field input-width" v-model="lead_first_name"
                                                    placeholder="Enter Lead First Name" maxlength="45"
                                                    name="lead_first_name" />
                                            </div>
                                             <div class="text-right">
                                                <!--span class="float-left text-danger mb-3"
                                                    v-show="errors.has('lead_first_name')">Lead First Name is
                                                    required
                                                </!--span-->
                                                <span class="input-field-length float-right">{{ lead_first_name.length }}/45</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12 col-sm-12 mt-1">
                                        <div class="w-100">
                                            <span class="input-label">Lead Middle Name</span>
                                            <div class="d-flex align-content-center mt-3">
                                                <input type="text" class="input-field input-width" v-model="lead_middle_name"
                                                    placeholder="Enter Lead Middle Name" maxlength="45" name="lead_middle_name" />
                                                <span class="pointer mt-2">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                        placement="top">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                            class="ml-2 v-hidden" style="width:25px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <div class="text-right" style="padding-right: 32px;">
                                                <!--<span class="float-left text-danger mb-3"
                                                    v-show="errors.has('lead_middle_name')">Lead Middle Name is
                                                    required
                                                </span>-->
                                                <span class="input-field-length float-right">{{ lead_middle_name.length }}/45</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                        <div class="w-100">
                                            <span class="input-label">Lead Last Name</span>
                                            <div class="d-flex align-content-center mt-3">
                                                <input type="text" class="input-field input-width" v-model="lead_last_name"
                                                    placeholder="Enter Lead Last Name" maxlength="45"
                                                    name="lead_last_name" />

                                            </div>
                                            <div class="text-right" >
                                                <!-- <span class="text-danger float-left mb-3 "
                                                    v-show="errors.has('lead_last_name')">Lead Last Name is required</span>-->
                                                 <span class="input-field-length float-right">{{ lead_last_name.length }}/45</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                        <div class="w-100">
                                            <span class="input-label">Phone Number</span>
                                            <div class="d-flex align-items-center  mt-3">
                                                <vue-tel-input v-if="$route.params.id != 'new'"
                                                    class="number-field-width-customer teleContactborderedDark new-align-tel ml-0"
                                                    style="height:46px!important" name="lead_user_phone"
                                                    placeholder="Enter Lead Contact Number"
                                                    v-bind="bindProps"
                                                    :defaultCountry="lead_user_phone.country_code || 'US'"
                                                    v-model="lead_user_phone.phone_number"
                                                    :disabledFormatting="false"
                                                    @onInput="leadPhoneInput"
                                                    :valid-characters-only="true"
                                                    :maxLen="15"
                                                    v-validate="{min:10}">
                                                </vue-tel-input>
                                                <vue-tel-input v-else
                                                    class="number-field-width-customer teleContactborderedDark new-align-tel ml-0"
                                                    style="height:46px!important" name="lead_user_phone"
                                                    placeholder="Enter Lead Contact Number"
                                                    v-bind="bindProps"
                                                    v-model="lead_user_phone.phone_number"
                                                    :disabledFormatting="false"
                                                    @onInput="leadPhoneInput"
                                                    :valid-characters-only="true"
                                                    :maxLen="15"
                                                    v-validate="{min:10}">
                                                </vue-tel-input>

                                            </div>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('lead_user_phone')">{{errors.first('lead_user_phone')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
                                        <div class="w-100">
                                            <span class="input-label">Lead E-mail</span>
                                            <div class="d-flex align-content-center mt-3">
                                                <input type="email" maxlength="100" class="input-field input-width email-text-valid"
                                                    v-model="lead_email" placeholder="Enter Lead  Email" v-validate="{email: true}"
                                                    name="lead_email" />
                                                <span class="pointer mt-2">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                        placement="top">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                            class="ml-2 v-hidden" style="width:25px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <div class="text-right" style="padding-right: 32px;">
                                                 <span class="input-field-length float-right">{{ lead_email.length }}/100</span>
                                                <span class="text-danger float-left" v-show="errors.has('lead_email')"
                                                    style="text-transform: none !important;">{{errors.first('lead_email')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End of Point of Contact-->
                        <!--Conventional -->
                        <div class="create-company-container w-100 " v-if="lead_source == 'Conventional'">
                            <div class="mt-6 pl-10 pr-2" v-if="conventialInfo">
                                <div class="pr-8">
                                    <div class="create-company-header d-flex align-items-center justify-content-between">
                                        <span class="fs-14 text-white">Conventional Info
                                            <el-tooltip class="item" effect="dark"
                                                content="Fields will be enabled if Lead Source (Channel) is Conventional"
                                                placement="top">
                                                <sup class="pl-1 fs-14 ml-02"><i class="icon-information text-white"
                                                        style="font-size: 15px;"></i></sup>
                                            </el-tooltip>
                                        </span>
                                    </div>
                                </div>
                                <div class="row mt-3 ">
                                    <div class="col-lg-8 col-md-12 col-sm-12 mt-4">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12 mt-2">
                                                <div class="w-100">
                                                    <span class="input-label">Location Introduced</span>
                                                    <div class="d-flex align-content-center mt-2 map-icon">
                                                        <gmap-autocomplete @place_changed="locationAddress"
                                                            class="input-white pr-8" id="autocompleteInput"
                                                            :value="location_introduced" placeholder="Enter Location">
                                                        </gmap-autocomplete>
                                                        <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                                            style="position: absolute;bottom: 12px; right: 75px;" />

                                                        <span class="pointer ml-4" @click="getLocation">
                                                            <img src="/static/images/images-new-theme/icons/GPS 2.svg"
                                                                style="height: 40px;" />
                                                        </span>

                                                    </div>
                                                    <!--div class="text-right" style="padding-right: 32px;">

                                                        <span class="text-danger float-left"
                                                            v-show="errors.has('location_introduced')"
                                                            style="text-transform: none !important;">Location
                                                            Introduced is
                                                            required</span>
                                                    </div-->
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 mt-2">
                                                <div class="w-100">
                                                    <span class="input-label">Lead Contact Via <sup
                                                        class="fs-14 ml-02 text-danger">*</sup></span>
                                                    <div class="d-flex align-items-center mt-3"
                                                        style="margin-top: .7rem !important;">
                                                        <multiselect v-validate="'required'"
                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                            :loading="load_contact_via" label="value" :searchable="true"
                                                            :options="source_type_options"
                                                            @open="loadLeadsSettings('contacted_via')"
                                                            name="lead_contact_type" v-model="lead_contact_type"
                                                            @search-change="SearchContactedVia"
                                                            placeholder="Select Contact">
                                                            <div class="add-vendor fw-500">
                                                                Add Lead Contact Type
                                                                <span
                                                                    class="text-secondary fw-500">'{{add_lead_contact_type}}'</span>
                                                                <i
                                                                    class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                            </div>
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">
                                                                    Lead Contact type is not found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Results Found
                                                                </div>
                                                            </template>
                                                        </multiselect>
                                                        <span class="pointer" @click="redirectSettings">
                                                            <el-tooltip class="item" effect="dark"
                                                                content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                                placement="top">
                                                                <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                                    class="ml-2 " style="width:25px" alt="">
                                                            </el-tooltip>
                                                        </span>
                                                    </div>
                                                    <div class="" style="padding-right: 32px;position:absolute">
                                                        <span class="text-danger float-left"
                                                        v-show="errors.has('lead_contact_type')"
                                                        style="text-transform: none !important;">Lead Contact Via is
                                                        required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                <div class="w-100">
                                                    <span class="input-label">Referred By</span>
                                                    <div class="d-flex align-items-center mt-3"
                                                        style="margin-top: .7rem !important;">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                            label="full_name" :loading="load_referred"
                                                            @close="resetEmployees" @search-change="searchAssigned($event,'referred')"
                                                            @open="fetchAssigned(null,'referred')" :internal-search="false"
                                                            :searchable="true" :options="assigned_to_type"
                                                            name="referred_by" v-model="referred_by"
                                                            placeholder="Select Referred ">
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfEmployees" />
                                                            </template>
                                                            <!--<template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">
                                                                    Referred type is not found</div>
                                                            </template>-->
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">
                                                                    No Results Found
                                                                </div>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                    <div class="text-right" style="padding-right: 32px;">
                                                        <span class="text-danger float-left"
                                                            v-show="errors.has('referred_by')"
                                                            style="text-transform: none !important;">Referrred
                                                            By is
                                                            required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                <div class="w-100">
                                                    <span class="input-label">Meeting type
                                                        <!-- <sup class="pl-1 fs-14 ml-02">*</sup> -->
                                                    </span>
                                                    <div class="d-flex align-items-center mt-3"
                                                        style="margin-top: .7rem !important;">
                                                        <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow" :hide-selected="true" :loading="load_meeting" label="value" @open="loadLeadsSettings('meeting_type')" :searchable="true" @search-change="searchMeetingType" :options="source_type_options" name="meeting_type"  v-model="meeting_type" placeholder="Select Meeting">
                                                            <div class="add-vendor fw-500">
                                                                Add Meeting Type
                                                                <span class="text-secondary fw-500">'{{add_meetingtype}}'</span>
                                                                <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                            </div>
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">
                                                                    Meeting type is not found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">
                                                                    No
                                                                    Results Found
                                                                </div>
                                                            </template>
                                                        </multiselect>
                                                        <span class="pointer" @click="redirectSettings">
                                                            <el-tooltip class="item" effect="dark"
                                                                content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                                placement="top">
                                                                <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                                    class="ml-2 " style="width:25px" alt="">
                                                            </el-tooltip>
                                                        </span>
                                                    </div>
                                                    <!-- <div class="text-right" style="padding-right: 32px;">
                                                            <span class="text-danger float-left"
                                                                v-show="errors.has('meeting_type')"
                                                                style="text-transform: none !important;">Meeting
                                                                Type is
                                                                required</span>
                                                        </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12 col-sm-12 mt-6">
                                        <div class="w-100">
                                            <span class="input-label">Secondary Attendees</span>
                                            <div class="d-flex align-content-center mt-2">
                                                <multiselect label="full_name"
                                                    class="diginew-multiselect secondary_height diginew-multiselect-placeholder diginew-multiselect-lightgrey greyblack no-default-icon diginew-multiselect-dark-grey diginew-multiselect-overflow"
                                                    :loading="load_secondary_attendees" @search-change="searchAssigned($event,'secondary')"
                                                    @open="fetchAssigned('','secondary')" :searchable="true" @close="resetEmployees" :multiple="true"
                                                    :options="assigned_to_type" trackBy="id" name="secondary_attendes_type"
                                                    v-model="secondary_attendes_type" :internal-search="false"
                                                    placeholder="Select Secondary Attendees">
                                                    <template slot="afterList">
                                                        <div v-observe-visibility="reachedEndOfEmployees" />
                                                    </template>
                                                    <!--<template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">
                                                            Secondary Attendees are not found</div>
                                                    </template>-->
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">
                                                            No
                                                            Results Found
                                                        </div>
                                                    </template>
                                                </multiselect>
                                                <span class="pointer">
                                                    <el-tooltip class="item" effect="dark"
                                                        content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                        placement="top">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                            class="ml-2 v-hidden" style="width:25px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <div class="text-right" style="padding-right: 32px;">
                                                <span class="text-danger float-left" v-show="errors.has('secondary_attendes')" style="text-transform: none !important;">Secondary Attendees is required</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--End of Conventional -->
                        <!--Social Media -->
                        <div class="create-company-container w-100" v-if="lead_source == 'Social Media'">
                            <div class="mt-6 px-10">
                                <div class="create-company-header d-flex align-items-center justify-content-between">
                                    <span class="fs-14 text-white">Social Media</span>
                                </div>
                                <div class="row mt-5 padding-right" v-for="(social,index) in social_media" :key="index">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                        <div class="w-100">
                                            <span class="input-label">Social Media Type <sup class="fs-14 ml-02 text-danger">*</sup></span>
                                            <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                    :loading="load_social_type" :searchable="true"
                                                    :options="source_type_options" label="value"
                                                    @open="loadLeadsSettings('social_media_type')"
                                                    @close="CheckSocialMediaUrl(index)"
                                                    @search-change="SearchSocialMedia"
                                                    v-validate="'required'"
                                                    :name="'social_media_type_type'+index" v-model="social.account_type"
                                                    placeholder="Select Social Media">
                                                    <template slot="afterList">
                                                        <div class="add-vendor fw-500" v-if="add_socialmedia"
                                                            @click="addSocialMediaType()">
                                                            Add Social Media Type <span
                                                                class="text-secondary fw-500"></span>
                                                            <i
                                                                class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                        </div>
                                                    </template>
                                                    <template slot="noOptions">
                                                        <div class="text-secondary text-center fw-600">
                                                            Social Media
                                                            is
                                                            not found</div>
                                                    </template>
                                                    <template slot="noResult">
                                                        <div class="text-secondary text-center fw-600">No
                                                            Results Found
                                                        </div>
                                                    </template>
                                                </multiselect>
                                                <span class="pointer" @click="redirectSettings">
                                                    <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="top">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 " style="width:25px" alt="">
                                                    </el-tooltip>
                                                </span>
                                            </div>
                                            <div class="text-right mt-1">
                                                <span class="float-left text-danger mb-3" v-show="errors.has('social_media_type_type'+index)">Social Media Type is Required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-12 mt-4">
                                        <div class="w-100">
                                            <span class="input-label">Links / URL <sup class="fs-14 ml-02 text-danger">*</sup></span>
                                            <div class="d-flex align-content-center mt-2">
                                                <input type="text" class="input-field input-width" style="height:42px !important;" :placeholder="social.account_type.value == 'Linkedin' ? 'https://www.linkedin.com' : social.account_type.value == 'Instagram' ? 'https://www.instagram.com' : social.account_type.value == 'Facebook' ? 'https://www.facebook.com' : social.account_type.value == 'twitter' ? 'https://www.twitter.com' : 'Please Select Social Media Type'" v-model="social.account_url" :style="index+1 < social_media.length" @input="inputMediaText($event, index)" @change="inputMediaText($event, index)" v-validate="{required: true, url: {require_protocol: true }}" :disabled="social.account_type == ''" :class="social.account_type == '' ? 'not-allowed' : ''" :name="'links'+index" />
                                                <i v-if="social_media.length > 1" @click="removeSocialMedia(index)" class="icon-minus-circle ml-2" style="color: #c93254; font-size: 25px; cursor:pointer!important;margin-top: 22px"></i>
                                                <i v-if="index+1 == social_media.length" @click="addSocialMedia" class="icon-plus-circle ml-2" style="color: #008a63; font-size: 25px; cursor:pointer!important;margin-top: 22px"></i>
                                            </div>
                                            <span class="float-left text-danger mb-3" v-if="social.account_url != '' && !social.valid ">{{social.account_type.value}} URL is Invalid</span>
                                            <span class="float-left text-danger mb-3" v-if="social.account_url == '' && errors.has('links'+index)">Link/URL is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--End of Social Media -->
                        <div class=" pb-6 pt-6">
                            <div v-if="disableButtonAndDisplayLoader == false" class="d-flex align-items-center justify-content-center">
                                <button class="btn new-cancel-button" @click="goTOListView()">Cancel</button>
                                <button class="btn new-save-button ml-5" @click="saveLeadsInfo" :disabled="fields_not_changed && con_fields_not_changed && enable_save_btn == false">Save</button>
                            </div>
                            <div v-else class="d-flex align-items-center justify-content-center">
                                <button class="btn btn-new-cancel-disable" disabled>Cancel</button>
                                <button class="btn btn-new-save-disabled btn-new-secondary ml-5" style="position: relative" disabled>Save
                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <success-message :message="$route.params.id == 'new' ? 'Lead Created successfully': 'Lead Updated successfully'"  modal_name="success-message" @hideSuccess="hideSuccess"></success-message>
    </div>

</template>
<script>
	import moment from "moment-timezone";
    const SuccessMessage = () => import("../SuccessMessage");
    import globals from '../globals';
    import { HalfCircleSpinner } from "epic-spinners";
    //import SuccessMessage from "./SuccessMessage";
    import { SweetModal } from 'sweet-modal-vue';
    import DatePicker from 'vue2-datepicker';
    import axios from "axios";
    import leads from '../mixins/leads';
    import convert from '../mixins/convert';
    import customers from '../mixins/customer';
    import Settings from "../mixins/settings";
    import { debounce } from 'lodash';
    import { EventBus } from '../eventBus/nav-bar-event';
    import { HollowDotsSpinner } from "epic-spinners";
    export default {
        data() {
            const value2date = (dateRange) => {
                const date = new Date(dateRange)
                return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
            }
            const date2value = (date) => {
                return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
            }
            return {
                enable_save_btn: false,
                stringified_response: "",
                con_stringified_response: "",
                secondary_serch_key: "",
                disableButtonAndDisplayLoader: false,
                qualifying_lead_loading: false,
                qualifying_lead: "",
                qualifying_lead_options: [],
                qualifying_lead_count: 0,
                scrollableQL: false,
                isQLVisible: "",
                temp_QL_options: [],
                selected_template_id: "",
                lead_details: null,
                bindProps: {
                    mode: "international",
                    defaultCountry: "US"
                },
                territory:'',
                territory_options:[],
                temp_territories: [],
                territory_loading:false,
                territory_count:0,
                territory_scrollable: false,
                territory_visible: false,
                date_iso: false,
                lead_first_name: '',
                lead_middle_name: '',
                lead_last_name: '',
                title_type: '',
                success_msg: 'Leads Created Successfully',
                warning_msg: '',
                title: '',
                lead_type_options: ['Cold Lead', 'Hot Lead', 'Warm Lead'],
                meeting: '',
                campaign_source: null,
                add_assigned_to: '',
                campaign_source_type: [],
                add_lead_contact_type: [],
                lead_email: '',
                lead_title: '',
                assigned_by: '',
                assignedList: [],
                lead: true,
                links: [""],
                industry: '',
                lead_source: 'Conventional',
                reffered_to: '',
                secondary_attendes: '',
                assigned_to: '',
                social_media_type: [],
                lead_type: null,
                add_secondary_attendes: '',
                add_lead_contact: '',
                add_leads_type: '',
                add_socialmedia: '',
                time: '',
                industry_type: [],
                lead_source_type: [],
                assigned_by_type: [],
                description: '',
                assigned_to_type: [],
                lead_start_date: moment(new Date().toUTCString()).format("YYYY-MM-DD"),
                lead_start_time: moment(new Date().toUTCString()).format("HH:mm"),
                lead_number_type_options: [],
                source_type_options: [],
                industry_type_options: ["Accommodation and Food Services","Administrative and Support, Waste Management and Remediation Services","Agriculture, Forestry, Fishing and Hunting","Arts, Entertainment and Recreation","Construction","Developer","Educational Services","EPC","Finance and Insurance","F&B","Health Care and Social Assistance","Information and Cultural Industries","Management of Companies and Enterprises","Manufacturing","Mining, Quarrying, and Oil and Gast Extraction","Other Businesses","Other Services (except public administration)","Professional, Scientific and Technical Services","Public Administration","Real Estate and Rental and Leasing","Residential Installation","Retail Trade","Transportation and Warehousing","Supplier","Utilities","Wholesale Trade"],
                time_type_options: [],
                conventinalTab: true,
                secondary_attendes_type: [],
                secondary_attendes_options: [],
                date: new Date(),
                company_name: '',
                Company: false,
                location_introduced: '',
                lead_contact_type: [],
                lead_contact: '',
                referred_by: '',
                referred_by_options: [],
                meeting_type: [],
                ptCount: 0,
                bCount: 0,
                reffered_to_type: [],
                lead_phone_number: '',
                lead_secondary_attendees: '',
                lead_user_phone: {
                    phone_number: "",
                    dial_code: "",
                    country_code: "",
                    phone_type: ""
                },
                phone: {
                    number: "",
                    isValid: false,
                    country: "IN",
                    dial_code: "91",
                },
                socialMedia: false,
                leadInfoTab: true,
                conventialInfo: true,
                Company: false,
                LeadSource: true,
                add_referred_by: '',
                //meeting_type_options: [],
                searchdata: '',
                listType: [],
                temp_listType: [],
                islistType: false,
                scrollableListType: false,
                selected_lead: 'Company',
                IndustryValidate : false,
                load_title: false,
                load_assigned_by : false,
                load_assigned_to : false,
                load_lead_type: false,
                load_industry : false,
                load_contact_via : false,
                load_referred :false,
                load_meeting: false,
                load_secondary_attendees: false,
                load_social_type : false,
                load_campaign :false,
                lead_source_options: [
                    "Conventional",
                    "Social Media"
                ],
                leads_settings_update: {},
                LeadChannel: false,
                social_media: [{
                    account_id: "",
                    account_type: "",
                    account_url: "",
                    logo: "",
                    valid: "",
                }, ],
                add_meetingtype: '',
                add_title: '',
                skip: 0,
                limit: 10,
                search_key: "",
                lead_number_type: {
                    name: 'Work',
                    image: 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/work-contact-icon.svg'
                },
                organisationSettings: null,
                ajaxCallInProgress: false,
                leadSettings: null,
                assignedSettings: null,
                leads_title_options: ['Dr','Miss','Mr','Mrs','Ms','Prof'],
                listType: false,
                //employees
                assign_loading: false,
                temp_employees: [],
                employee_count: 0,
                employee_scrollable: false,
                employee_visible: false,
                address: {
                    address_string: "",
                    address_type: 'office',
                    building_no: '',
                    street1: '',
                    street2: '',
                    city: '',
                    township: '',
                    state: '',
                    zip_code: '',
                    country: '',
                },
                location: {
                    street: '',
                    city: '',
                    township: '',
                    country: '',
                    zip_code: '',
                    latitude: '',
                    longitude: ''
                },
                success_lead: false,
                lead_id: null,
                formatted_date: null,
                store_attendees: [],
                timeDefault: moment().tz(moment.tz.guess()).format("LTS z"),
				timeNewYork: moment().tz("America/New_York").format("LTS z"),
				timeLondon: moment().tz("Europe/London").format("LTS z"),
				timeKolkata: moment().tz("Asia/Kolkata").format("LTS z"),
				timeSingapore: moment().tz("Asia/Singapore").format("LTS"),
                timeYangon: moment().tz("Asia/Yangon").format("LTS"),
                default_country: null,
                company_email: '',
                urlFacebook: "",
                isValidFacebook: true,
                regexFacebook: /^http(s*):\/\/(www.)*facebook\.com/,
                nameTwitter: "twitter_url_regex",
                urlTwitter: "",
                isValidTwitter: true,
                regexTwitter: /^http(s*):\/\/(www.)*twitter\.com/,
                nameInstagram: "instagram_url_regex",
                urlInstagram: "",
                isValidInstagram: true,
                regexInstagram: /^http(s*):\/\/(www.)*instagram\.com/,
                nameLinkedin: "linkedin_url_regex",
                urlLinkedin: "",
                isValidLinkedin: true,
                regexLinkedin:  /^http(s*):\/\/(www.)*linkedin\.com/,
                urlReddit: "",
                isValidReddit: true,
                regexReddit:  /^http(s*):\/\/(www.)*reddit\.com/,
            }
        },
        mixins: [leads, convert,customers,Settings],
        methods: {
            enableSave(){
                this.enable_save_btn = true;
            },
            goTOListView(){
                this.$router.push({
                    path: '/listleads'
                })
            },
            getSelectedTemplateData(data){
                this.selected_template_id = data.id
            },
            async loadQualifyingLeadListDebouncer(search_key){
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: search_key
                }
                let response = await this.getQualifyingLeadList(params)
                this.qualifying_lead_options = response.response
                this.qualifying_lead_count = response.response.length
                this.scrollableQL = false
            },
            async reachedEndOfQualifyingLead(reached){
                this.isQLVisible = reached
                if (reached) {
                    if (this.scrollableQL == false) {
                        this.qualifying_lead_loading = true
                        let params ={
                            skip: this.qualifying_lead_count,
                            limit: 10,
                            search_key: '',
                        }
                        let response = await this.getQualifyingLeadList(params)
                        this.temp_QL_options = response.response.length;
                        if (response.skip == this.qualifying_lead_count) {
                            if (this.temp_QL_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.qualifying_lead_options.push(el);
                                });
                                this.qualifying_lead_count += response.response.length;
                                this.qualifying_lead_loading = false
                            } else {
                                this.scrollableQL = true
                                this.qualifying_lead_loading = false
                            }
                        }
                        this.qualifying_lead_loading = false
                    }
                }
            },
            inputMediaText:function(e,index){
                const url = e.target.value
                this.isURLValidFacebook(url,index);
            },
            isURLValidFacebook(url_regex,indx) {
                if(this.social_media[indx].account_type.value == 'Facebook'){
                    this.isValidFacebook = this.regexFacebook.test(url_regex)
                    this.social_media[indx].valid = this.isValidFacebook
                }
                if(this.social_media[indx].account_type.value == 'Linkedin'){
                    this.isValidLinkedin = this.regexLinkedin.test(url_regex)
                    this.social_media[indx].valid = this.isValidLinkedin
                }
                if(this.social_media[indx].account_type.value == 'Instagram'){
                    this.isValidInstagram = this.regexInstagram.test(url_regex)
                    this.social_media[indx].valid = this.isValidInstagram
                }
                if(this.social_media[indx].account_type.value == 'twitter'){
                    this.isValidTwitter = this.regexTwitter.test(url_regex)
                    this.social_media[indx].valid = this.isValidTwitter
                }
                if(this.social_media[indx].account_type.value == 'Reddit'){
                    this.isValidReddit = this.regexReddit.test(url_regex)
                    this.social_media[indx].valid = this.isValidReddit
                }
            },
            CheckSocialMediaUrl(indx){
                let url_regex = this.social_media[indx].account_url
                if(this.social_media[indx].account_type.value == 'Facebook'){
                    this.isValidFacebook = this.regexFacebook.test(url_regex)
                    this.social_media[indx].valid = this.isValidFacebook
                }
                if(this.social_media[indx].account_type.value == 'Linkedin'){
                    this.isValidLinkedin = this.regexLinkedin.test(url_regex)
                    this.social_media[indx].valid = this.isValidLinkedin
                }
                if(this.social_media[indx].account_type.value == 'Instagram'){
                    this.isValidInstagram = this.regexInstagram.test(url_regex)
                    this.social_media[indx].valid = this.isValidInstagram
                }
                if(this.social_media[indx].account_type.value == 'twitter'){
                    this.isValidTwitter = this.regexTwitter.test(url_regex)
                    this.social_media[indx].valid = this.isValidTwitter
                }
                if(this.social_media[indx].account_type.value == 'Reddit'){
                    this.isValidReddit = this.regexReddit.test(url_regex)
                    this.social_media[indx].valid = this.isValidReddit
                }
            },
            limitSecondaryAttendees(count) {
                return `+ ${count} more`
            },
            //Hiding the success popup modal
            hideSuccess() {
                this.success_lead = false;
                setTimeout(() => {
                    localStorage.setItem("leads_type",'Manual')
                    this.$router.push({
                        path: '/leads/viewLeads/' + this.lead_id
                    })
                }, 500);
            },
            /**@params = number
            /**@params = isvalid */
            /**@params = country*/
            //checking the validity, country and dial code
            leadPhoneInput({number,isValid,country}) {
                this.same_bill = false
                this.phone.number = number;
                this.phone.isValid = isValid;
                this.phone.country = country;
                this.lead_user_phone.dial_code = this.phone.country.dialCode || ''
                this.lead_user_phone.country_code = this.phone.country.iso2 || ''
            },
             /**@params = place*/
            //Spliting the address which is seleted from location field
            locationAddress(place) {
                let currentPlace = place;
                let address = place.formatted_address.split(', ')
                this.location.country = address[address.length - 1] || ''
                this.location.township = address[address.length - 2] || ''
                this.location.state = address[address.length - 3] || ''
                this.location.city = currentPlace.vicinity
                this.location.latitude = currentPlace.geometry.location.lat()
                this.location.longitude = currentPlace.geometry.location.lng()
                this.locationLatLong(this.location.latitude, this.location.longitude)
            },
            //getting lang and lat data from this google API's
            /**@params = latitude , @params = longitude*/
            locationLatLong(latitude, longitude) {
                axios.get(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY`
                    )
                    .then(results => {
                        var i = 0
                        var street_name
                        var street_number
                        /*using this loop we're fetching the list of similar address what we searched for*/
                        for (i = 0; i < results.data.results.length; i++) {
                            for (var j = 0; j < results.data.results[i].address_components.length; j++) {
                                for (var k = 0; k < results.data.results[i].address_components[j].types
                                    .length; k++) {
                                    if (results.data.results[i].address_components[j].types[k] == "postal_code") {
                                        this.location.zip_code = results.data.results[i].address_components[j]
                                            .short_name;
                                    }
                                    if (results.data.results[i].address_components[j].types[k] == 'route') {
                                        street_name = results.data.results[i].address_components[j].short_name;
                                    }
                                    if (results.data.results[i].address_components[j].types[k] == 'street_number') {
                                        street_number = results.data.results[i].address_components[j].short_name;
                                    }
                                }
                            }
                        }
                        this.location.street = street_number + ',' + ' ' + street_name
                        this.address.street1 = street_name
                        this.address.city = this.location.city
                        this.address.zip_code = this.location.zip_code
                        this.address.state = this.location.township
                        this.address.country = this.location.country
                        this.address.township = this.location.state
                        this.address.building_no = this.location.city.substr(0, 10);
                        this.address.latitude =  latitude
                        this.address.longitude = longitude
                    })
            },
            getLocation() {
                if (navigator.geolocation.getCurrentPosition) {
                    // timeout at 60000 milliseconds (60 seconds)
                    var options = {
                        enableHighAccuracy: false,
                        timeout: 30000, // milliseconds (30 seconds)
                        maximumAge: 600000
                    }; // milliseconds (10 minutes)
                    navigator.geolocation.getCurrentPosition(
                        this.showLocation,
                        this.errorHandler,
                        options
                    );
                } else {
                    alert("Sorry, browser does not support geolocation!");
                }
            },
            showLocation(position) {
                this.location.latitude = position.coords.latitude;
                this.location.longitude = position.coords.longitude;
                let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
                let calllatlong = axios.create();
                delete calllatlong.defaults.headers.common['Authorization'];
                calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue +
                        "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
                    .then(response => {
                        let address = response.data.results[0].formatted_address.split(", ");
                        this.location.township = address[address.length - 3] || "";
                        this.location.city = address[address.length - 3] || "";
                        this.location.country = address[address.length - 1];
                        let statezip = address[address.length - 2] ? address[address.length - 2].split(" ") : ["",
                            ""
                        ];
                        this.location.zip_code = statezip[1] || "";
                        this.location.state = statezip[0].match(/^[a-zA-Z]+$/) ? statezip[0] : statezip[1].match(
                            /^[a-zA-Z]+$/) ? statezip[1] : "";
                        this.location.street = address[address.length - 4] || "";
                        this.location_introduced =
                        (this.location.street ? this.location.street + ',' : '') +
                        (this.location.township ? this.location.township + ',' : '') +
                        (this.location.city ? this.location.city + ',' : '') +
                        (this.location.country ? this.location.country + ',' : '') +
                        (this.location.zip_code ? this.location.zip_code + ',' : '') +
                        (this.location.state ? this.location.state : '');
                        //this.location_introduced = response.data.results[0].formatted_address;
                    })
                    .catch(e => {
                        // this.errors.push(e)
                    });
            },
            errorHandler(err) {
                if (err.code == 1) {
                    // alert("Error: Access is denied!");
                } else if (err.code == 2) {
                    // alert("Error: Position is unavailable!");
                }
            },

             //Changing the lead type using this method
            /**@params = selected_lead*/
            changeLead(selected_lead) {
                var data = selected_lead;
                if (data == 'Company') {
                     //creating the lead(company) for the first time
                    if(this.$route.params.id == 'new'){
                        this.$router.push({
                            path: '/leads/createLeads/new'
                        })
                    } else {
                        //editing the lead(company)
                        this.$router.push({
                            path: "/leads/createLeads/" + this.$route.params.id
                        })
                    }
                    this.LeadChannel = true
                    this.LeadSource = false
                    this.IndustryValidate = true
                } else {
                    //creating the lead(individual) for the first time
                    if(this.$route.params.id == 'new') {
                        localStorage.setItem('create_new_lead_company', JSON.stringify(this.switch_lead))
                        this.$router.push({
                            path: '/leads/createLeads/individual/new'
                        })
                    } else {
                        //editing the lead(individual)
                        this.$router.push({
                            path: "/leads/createLeads/individual/" + this.$route.params.id
                        })

                    }
                    this.LeadChannel = false
                    this.LeadSource = true
                    this.IndustryValidate = false
                }

            },
             //Save the lead data
            saveLeadsInfo() {
                this.$validator.validateAll().then(async result => {
                    let url = false
                    //checking the socail media valdiation
                    let social_media_url_validator = this.social_media.every(x => x.valid == true)
                    let convential_info = false
                    //checking the industry type length
                    if (this.industry_type.length) {
                        this.create_leads['industry_type'] = this.industry_type
                    }
                    //checking the social media data(if presents)
                    if (this.lead_source == 'Social Media') {
                        if(social_media_url_validator){
                            this.social_media.forEach(social => {
                                if (social.account_type && social.account_url) {
                                    url = false
                                    let social = []
                                    this.social_media.forEach(x => {
                                        social.push({
                                            media_type: x.account_type.value,
                                            url: x.account_url
                                        })
                                    })
                                    this.create_leads['source'] = social
                                } else {
                                    url = true
                                }
                            })
                        }
                    } else {
                        if (this.lead_contact_type && this.meeting_type) {
                            convential_info = false
                            this.create_leads['source'] = {
                                address: {
                                    street: this.location.street,
                                    city: this.location.city,
                                    state: this.location.state,
                                    zip_code: this.location.zip_code,
                                    country: this.location.country,
                                    township: this.location.township,
                                    latitude: this.location.latitude || '0.00',
                                    longitude: this.location.longitude || '0.00',
                                    address_type: "work"
                                },
                                lead_contact_via: this.lead_contact_type.value,
                                referred_by_name: this.referred_by ? this.referred_by.full_name : '',
                                referred_by: this.referred_by ? this.referred_by.user_id : '',
                                meeting_type: this.meeting_type.value,
                                secondary_attendees: this.secondary_attendes_type.map(x => {
                                    return x.email
                                })
                            }
                        } else {
                            convential_info = true
                        }
                    }
                    //checking validation and checking that social media url is present or not
                    /**@params = result , @params = url*/
                    if (result && !url ) {
                        this.disableButtonAndDisplayLoader = true;
                        this.create_leads['company_name'] = this.company_name
                        this.create_leads['company_email'] = this.company_email
                        let api_url = null
                        let response
                        try{
                            if (this.$route.params.id != 'new') {
                                this.create_leads['id'] = this.$route.params.id
                                this.success_msg = "Leads Updated Successfully"
                                response = await this.updateLeadActiveDetails(this.$route.params.id, this.create_leads)
                                localStorage.setItem("leads_type","Manual")
                            } else {
                                response = await this.createSalesLeads(this.create_leads)
                                localStorage.setItem("leads_type","Manual")
                            }
                        } catch (error){
                            this.disableButtonAndDisplayLoader = false;
                            this.warning_msg = error
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                        this.success_lead = true;
                        this.lead_id = this.$route.params.id == 'new' ? response.lead_id : this.$route
                            .params.id
                        setTimeout(() => {
                            this.disableButtonAndDisplayLoader = false;
                            this.$modal.show('success-message');
                        }, 1000)
                    } else if (url) {
                        this.warning_msg = "Please Enter Social Media Details"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.disableButtonAndDisplayLoader = false;
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                    /*else if (convential_info) {
                        this.warning_msg = "Please Enter Location"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }*/
                })
            },
            //adding the blank structure of social media
            addSocialMedia() {
                this.social_media.push({
                    account_id: "",
                    account_type: "",
                    account_url: "",
                    logo: "",
                });
            },
             //remove structure of social media
            /**@params = index*/
            removeSocialMedia(index) {
                this.social_media.splice(index, 1);
            },
            //Showing/hiding the lead info tab
            showHideLeadInfo() {
                if (this.leadInfoTab) {
                    this.leadInfoTab = false;
                } else {
                    this.leadInfoTab = true;
                }
            },
            //Searching the social media type
            /**@params = search_key*/
            searchSocialMediaType(search_key) {
                let letters = /^[A-Za-z]+$/;
                if (search_key.match(letters)) {
                    this.add_socialmedia = search_key;
                } else {
                    this.add_socialmedia = ''
                }
            },
            //Searching the Industry type
            /**@params = search_key*/
            searchIndustryType(search_key) {
                let letters = /^[A-Za-z]+$/;
                if (search_key.match(letters)) {
                    this.add_industry_type = search_key;
                } else {
                    this.add_industry_type = ''
                }
            },
            //It's redirecting to the settings page and to respective component
            changeView(){
                let territory = true
                let routeData = this.$router.resolve({name: 'Settings', query: {territory:territory}});
                window.open(routeData.href, '_blank');
            },
            //Searching the territory for given input//
            /**@params = search*/
            async searchTerritoryDebouncer(search) {
                this.territory_loading = true
                /**@params = skip, /**@params = limit,@params = search_key,@params = hierarchy_level*/
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: search,
                    // hierarchy_level:'all'
                }
                let response = await this.getTerritoryList(params)
                this.territory_options = response.response
                 //filtering territory_options to remove the redundant territory
                this.territory_options = this.territory_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.territory_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.territory_count = this.territory_options.length
                this.territory_loading  = false
                this.territory_scrollable = false
            },
            //Fetch the territory//
            async fetchTerritory(){
                this.territory_loading = true
                /**@params = skip, /**@params = limit,@params = search_key,@params = hierarchy_level*/
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: "",
                    // hierarchy_level:'all'
                }
                let response = await this.getTerritoryList(params)
                this.territory_options = response.response
                //filtering territory_options to remove the redundant territory
                this.territory_options = this.territory_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.territory_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.territory_count = this.territory_options.length
                this.territory_loading  = false
                this.territory_scrollable = false
            },
            //lazy loading of territory
            /**@params = reached*/
            async reachedEndOfTerritories(reached) {
                this.territory_visible = reached
                if (reached) {
                    if (this.territory_scrollable == false) {
                        this.territory_loading = true
                        let response = await this.getTerritoryList({
                            skip: this.territory_count,
                            limit: 10,
                            search_key: "",
                            // hierarchy_level:'all'
                        })
                        this.temp_territories = response.response.length;
                        if (response.skip == this.territory_count) {
                            if (this.temp_territories > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.territory_options.push(el);
                                });
                                this.territory_options = this.territory_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.territory_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.territory_count += response.response.length;
                                this.territory_loading = false
                            } else {
                                this.territory_scrollable = true
                                this.territory_loading = false
                            }
                        }
                        this.territory_loading = false
                    }
                }
            },
            //setting the limit for territory
            /**@params = count*/
            limitTerritory(count){
                return `+ ${count} more`
            },
            //remove territory
            /**@params = option*/
            removeTerritory(option){
                this.temp_territories.forEach((el,index)=>{
                    if(el._id == option._id){
                        this.temp_territories.splice(index,1)
                    }
                })
            },
            //Calling this method in the mounted to load the meeitngs and social media
            // async loadOrganisationSettings() {
            //     this.getMeeting()
            //     this.getSocialMedia()
            // },
            //Get meeting data for meeting type
            // async getMeeting() {
            //     this.meeting_type_options = []
            //     let params = {
            //         type: ["meeting_type"],
            //         operation: "dropdown",
            //         skip: 0,
            //         limit: 50,
            //         search_key: ""
            //     }
            //     let response = await this.getLeadSettings(params);
            //     this.meeting_type_options = response.response.meeting_type
            // },
            //Get data for social media type
            // async getSocialMedia() {
            //     this.social_media_options = []
            //     /**@params = type,@params = operation,@params = skip,@params = limit, @params = search_key*/
            //     let params = {
            //         type: ["social_media_type"],
            //         operation: "dropdown",
            //         skip: 0,
            //         limit: 50,
            //         search_key: ""
            //     }
            //     let response = await this.getLeadSettings(params)
            //     this.social_media_type_options = response.response.social_media_type
            // },
            //Searching Assigned by, Assigned to, Secondary Attendees and Referred By//
            async searchAssignedDebouncer(item,type) {
                this.secondary_serch_key = item
                this.dropdown_type = type
                 //loader is getting true as per the condition
                if(this.dropdown_type == "assigned"){
                    this.load_assigned_to = true
                } else if(this.dropdown_type == "assigned_by"){
                    this.load_assigned_by = true
                } else if(this.dropdown_type == "secondary"){
                    this.load_secondary_attendees = true
                } else if(this.dropdown_type == "referred"){
                    this.load_referred = true
                }
                /**@params = skip,@params = limit,@params = company_id, @params = search_key, @params = sort_value, @params = sort_key*/
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.secondary_serch_key,
                    company_id: this.loggedInUser.company_id,
                    sort_key:'full_name',
                    sort_value:1
                }
                let response = await this.getAssigned(params)
                this.assigned_to_type = response.response
                this.assigned_to_type.forEach(x => {
                    this.store_attendees.push(x)
                })
                this.employee_count = this.assigned_to_type.length
                //loader is getting false as per the condition
                if(this.dropdown_type == 'assigned'){
                    this.load_assigned_to = false
                } else if(this.dropdown_type == 'assigned_by'){
                    this.load_assigned_by = false
                } else if(this.dropdown_type == 'secondary'){
                    this.load_secondary_attendees = false
                }else if(this.dropdown_type == "referred"){
                    this.load_referred = false
                }
                this.employee_scrollable = false
            },
            //Fetching Assigned by, Assigned to, Secondary Attendees and Referred By//
            /**@params = item,@params = type*/
            async fetchAssigned(item,type) {
                this.dropdown_type = type
                if(this.dropdown_type == "assigned"){
                    this.load_assigned_to = true
                } else if(this.dropdown_type == "assigned_by"){
                    this.load_assigned_by = true
                } else if(this.dropdown_type == "secondary"){
                    this.load_secondary_attendees = true
                }else if(this.dropdown_type == "referred"){
                    this.load_referred = true
                }
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.secondary_serch_key,
                    company_id: this.loggedInUser.company_id,
                    sort_key:'full_name',
                    sort_value:1
                }
                let response = await this.getAssigned(params)
                this.assigned_to_type = response.response
                this.assigned_to_type.forEach(x => {
                    this.store_attendees.push(x)
                })
                this.employee_count = this.assigned_to_type.length
                if(this.dropdown_type == 'assigned'){
                    this.load_assigned_to = false
                } else if(this.dropdown_type == 'assigned_by'){
                    this.load_assigned_by = false
                } else if(this.dropdown_type == 'secondary'){
                    this.load_secondary_attendees = false
                } else if(this.dropdown_type == "referred"){
                    this.load_referred = false
                }
                this.employee_scrollable = false
            },
            //lazy loading of Assigned by, Assigned to, Secondary Attendees and Referred By//
            /**@params = reached*/
            async reachedEndOfEmployees(reached) {
                this.employee_visible = reached
                if (reached) {
                    if (this.employee_scrollable == false) {
                        if(this.dropdown_type == 'assigned'){
                            this.load_assigned_to = true
                        } else if(this.dropdown_type == 'assigned_by'){
                            this.load_assigned_by = true
                        } else if(this.dropdown_type == 'secondary'){
                            this.load_secondary_attendees = true
                        } else if(this.dropdown_type == "referred"){
                            this.load_referred = true
                        }
                        let response = await this.getAssigned({
                            skip: this.employee_count,
                            limit: 10,
                            search_key: this.secondary_serch_key,
                            company_id: this.loggedInUser.company_id,
                            sort_key:'full_name',
                            sort_value:1
                        })
                        this.temp_employees = response.response.length;
                        if (response.skip == this.employee_count) {
                            if (this.temp_employees > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.assigned_to_type.push(el);
                                });
                                this.assigned_to_type = this.assigned_to_type.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.assigned_to_type.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.employee_count += response.response.length;
                                if(this.dropdown_type == 'assigned'){
                                    this.load_assigned_to = false
                                } else if(this.dropdown_type == 'assigned_by'){
                                    this.load_assigned_by = false
                                } else if(this.dropdown_type == 'secondary'){
                                    this.load_secondary_attendees = false
                                } else if(this.dropdown_type == "referred"){
                                    this.load_referred = false
                                }
                            } else {
                                this.employee_scrollable = true
                                if(this.dropdown_type == 'assigned'){
                                    this.load_assigned_to = false
                                } else if(this.dropdown_type == 'assigned_by'){
                                    this.load_assigned_by = false
                                } else if(this.dropdown_type == 'secondary'){
                                    this.load_secondary_attendees = false
                                }else if(this.dropdown_type == "referred"){
                                    this.load_referred = false
                                }
                            }
                        }
                        if(this.dropdown_type == 'assigned'){
                            this.load_assigned_to = false
                        } else if(this.dropdown_type == 'assigned_by'){
                            this.load_assigned_by = false
                        } else if(this.dropdown_type == 'secondary'){
                            this.load_secondary_attendees = false
                        } else if(this.dropdown_type == "referred"){
                            this.load_referred = false
                        }
                    }
                }
            },
            //Reset the Assigned by, Assigned to, Secondary Attendees and Referred By
            resetEmployees() {
                this.employee_scrollable = false
                this.employee_visible = false
                this.employee_count = 0
                this.temp_employees = []
                this.assign_loading = false
            },
            //Search the Title
            searchTitle(search_key) {
                let letters = /^[A-Za-z]+$/;
                if (search_key.match(letters)) {
                    this.add_title = search_key;
                } else {
                    this.add_title = ''
                }
            },
            //Search Lead Type
            searchLeadsType(search_key) {
                let letters = /^[A-Za-z]+$/;
                if (search_key.match(letters)) {
                    this.add_leads_type = search_key;
                } else {
                    this.add_leads_type = ''
                }
            },
            //Add Social Media Type
            async addSocialMediaType() {
                if (this.add_socialmedia) {
                    this.leads_settings_update = this.organisationSettings.leads_settings
                    this.leads_settings_update.social_media_type.push(this.add_socialmedia);
                    try {
                        /**@params = this.leads_settings_update*/
                        let param = {
                            leads_settings: this.leads_settings_update
                        }
                        let res = await this.$http.post("/organisation_settings/add", param);
                        if (res.data.status_id == 1) {
                            this.success_msg = res.data.response
                            this.$refs.success_modal.open();
                            setTimeout(() => {
                                this.$refs.success_modal.close();
                            }, 1000);
                        }
                    } catch (reason) {
                        this.warning_msg = reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 1000);
                    }
                }
            },
            //It's redirecting to Settings Page
            redirectSettings() {
                let routeData = this.$router.resolve({name: 'Settings'});
                window.open(routeData.href, '_blank');
            },
            //It's loading the Social Media Type, Meeting Type, Contacted Via, Campaign Source//
            /**@params = value*/
            async AssignSocialMedia(index){
                this.social_media.forEach((el, el_index) => {
                    if(index == el_index){
                        this.social_media[index] = [{
                            account_id: "",
                            account_type: "",
                            account_url: "",
                            logo: ""
                        },]
                    }
                })
            },
            async loadLeadsSettings(value) {
                this.source_type_options = []
                let type = value;
                if(type == 'social_media_type'){
                    this.load_social_type = true
                } else  if(type == 'meeting_type'){
                    this.load_meeting= true
                } else  if(type == 'contacted_via'){
                    this.load_contact_via = true
                } else  if(type == 'campaign_source'){
                    this.load_campaign= true
                }
                /**@params = type,@params = limit,@params = operation, @params = search_key, @params = skip*/
                let params = {
                    type: [value],
                    operation: "dropdown",
                    skip: 0,
                    limit: 50,
                    search_key: ""
                }
                let response = await this.getLeadSettings(params)
                 //Storing the repsonse in the respective options
                if (response.response.hasOwnProperty('campaign_source')) {
                    this.source_type_options = response.response.campaign_source
                } else if (response.response.hasOwnProperty('contacted_via')) {
                    this.source_type_options = response.response.contacted_via
                } else if (response.response.hasOwnProperty('meeting_type')) {
                    this.source_type_options = response.response.meeting_type
                } else if (response.response.hasOwnProperty('social_media_type')) {
                    this.source_type_options = response.response.social_media_type
                }
                if(type == 'social_media_type'){
                    this.load_social_type = false
                } else  if(type == 'meeting_type'){
                    this.load_meeting= false
                } else  if(type == 'contacted_via'){
                    this.load_contact_via = false
                } else  if(type == 'campaign_source'){
                    this.load_campaign = false
                }
            },
            //API Call of Search Meeting Type
            async searchMeetingTypeDebouncer(search_key) {
                let letters = /^[A-Za-z]+$/;
                if (search_key.match(letters)) {
                    this.add_meetingtype = search_key;
                } else {
                    this.add_meetingtype = ''
                }
                this.source_type_options = []
                this.load_meeting= true
                 /**@params = type,@params = operation, @params = search_key, @params = skip, @params = limit*/
                let params = {
                    type: ['meeting_type'],
                    operation: "dropdown",
                    skip: 0,
                    limit: 50,
                    search_key: this.add_meetingtype
                }
                let response = await this.getLeadSettings(params)
                this.source_type_options = response.response.meeting_type
                this.load_meeting= false
            },
            //API Call of Search Social Media
            async SearchSocialMediaDebouncer(){
                this.source_type_options = []
                this.load_social_type = true
                /**@params = type,@params = operation, @params = search_key, @params = skip, @params = limit*/

                let params = {
                    type: ['social_media_type'],
                    operation: "dropdown",
                    skip: 0,
                    limit: 50,
                    search_key: ""
                }
                let response = await this.getLeadSettings(params)
                this.source_type_options = response.response.social_media_type
                this.load_social_type = false
            },
            //API Call of Search Contacted Via
            /**@params = key*/
            async SearchContactedViaBouncer(key){
                this.load_contact_via = true
                /**@params = type,@params = operation, @params = search_key, @params = skip, @params = limit*/
                let params = {
                    type: 'contacted_via',
                    operation: "dropdown",
                    skip: 0,
                    limit: 50,
                    search_key: key
                }
                let response = await this.getLeadSettings(params)
                if (response.response.hasOwnProperty('contacted_via')) {
                    this.source_type_options = response.response.contacted_via
                }
                this.load_contact_via = false
            },
            //Api call to load the lead details
            async SearchCampaignSourceDebouncer(key){
                this.source_type_options = []
                this.load_campaign= true
                let params = {
                    type: 'campaign_source',
                    operation: "dropdown",
                    skip: 0,
                    limit: 50,
                    search_key: key
                }
                let response = await this.getLeadSettings(params)
                if (response.response.hasOwnProperty('campaign_source')) {
                    this.source_type_options = response.response.campaign_source
                }
                this.load_campaign = false
            },
            //Api call to load the lead details
            async loadLeadDetails() {
                this.ajaxCallInProgress = true
                let response = await this.getLeadActiveDetails(this.$route.params.id)
                this.lead_details = response.response
                this.lead_title = this.lead_details.title
                this.lead_first_name = this.lead_details.first_name
                if(this.lead_details.territory_id != ""){
                    this.territory = {name: this.lead_details.territory, id: this.lead_details.territory_id}
                }
                this.lead_middle_name = this.lead_details.middle_name
                this.lead_last_name = this.lead_details.last_name
                this.lead_email = this.lead_details.lead_email.toLowerCase()
                this.formatted_date = this.lead_details.lead_date
                this.qualifying_lead = {
                    qualifying_lead_name: this.lead_details.qualifying_lead_template_name
                }
                this.selected_template_id = this.lead_details.qualifying_lead_template_id
                this.lead_user_phone = {
                    phone_number: this.lead_details.lead_number.phone_number || '',
                    dial_code: this.lead_details.lead_number.dial_code || '',
                    country_code: this.lead_details.lead_number.country_code || '',
                    phone_type: this.lead_details.lead_number.phone_type || ''
                }
                this.phone = {
                    number: this.lead_details.lead_number.phone_number || '',
                    isValid: false,
                    country: {
                        dialCode: this.lead_details.lead_number.dial_code || '',
                        iso2: this.lead_details.lead_number.country_code || ''
                    }
                }
                this.campaign_source = {
                    value: this.lead_details.campaign_source
                }
                this.assigned_by = {
                    user_id: this.lead_details.assigned_by,
                    full_name: this.lead_details.assigned_by_name
                }
                this.assigned_to = {
                    user_id: this.lead_details.assigned_to,
                    full_name: this.lead_details.assigned_to_name
                }
                this.industry_type = this.lead_details.industry_type
                this.company_name = this.lead_details.company_name
                this.company_email = this.lead_details.company_email
                 //Lead conventional details//
                if (this.lead_details.lead_source == 'conventional') {
                    this.lead_details.lead_source = 'Conventional'
                    this.lead_source = this.lead_details.lead_source
                    this.location = {
                        street: this.lead_details.source.address.street,
                        city: this.lead_details.source.address.city,
                        township: this.lead_details.source.address.township,
                        country: this.lead_details.source.address.country,
                        zip_code: this.lead_details.source.address.zip_code,
                        state:this.lead_details.source.address.state,
                        latitude: this.lead_details.latitude,
                        longitude: this.lead_details.longitude
                    }
                    this.location_introduced =
                    (this.location.street ? this.location.street + ',' : '') +
                    (this.location.city ? this.location.city + ',' : '') +
                    (this.location.state ? this.location.state + ',' : '') +
                    (this.location.township ? this.location.township + ',' : '') +
                    (this.location.country ? this.location.country + ',' : '') +
                    (this.location.zip_code ? this.location.zip_code : '')
                    this.lead_contact_type = {
                        value: this.lead_details.source.lead_contact_via
                    }
                    if(this.lead_details.source.meeting_type != ""){
                        this.meeting_type = {
                            value: this.lead_details.source.meeting_type
                        }
                    }
                    if(this.lead_details.source.referred_by != ""){
                        this.referred_by = {
                            full_name: this.lead_details.source.referred_by_name,
                            user_id: this.lead_details.source.referred_by
                        }
                    }
                    this.secondary_attendes_type = []
                    this.lead_details.source.secondary_attendees.forEach(x => {
                        this.searchAssigned(x)
                    })
                    setTimeout(() => {
                        this.store_attendees.forEach(x => {
                            this.secondary_attendes_type.push(x)
                        })
                        this.assign_loading = false
                    }, 3000);
                }  //Social Media details//
                else {
                    this.lead_details.lead_source = 'Social Media'
                    this.lead_source = this.lead_details.lead_source
                    this.social_media = []
                    this.lead_details.source.forEach((y,index) => {
                        this.social_media.push({
                            account_type : {
                                value: y.media_type
                            },
                            account_url : y.url,
                            account_id : y.id,
                        })

                    })
                    this.social_media.forEach((el,index)=> {
                        this.isURLValidFacebook(el.account_url,index)
                    })
                }
                //removing the under-score using ternary operator for lead type
                this.lead_type = this.lead_details.lead_type == 'cold_lead' ? "Cold Lead" : this.lead_details.lead_type == 'hot_lead' ? 'Hot Lead' : 'Warm Lead'
                this.description = this.lead_details.description
                this.default_country = this.phone.country.country_code
                this.ajaxCallInProgress = false
                this.lead_start_time = this.lead_details.lead_time
                this.stringified_response = JSON.stringify(this.create_leads)
                setTimeout(() => {
                    this.con_stringified_response = JSON.stringify(this.conventional_data)
                }, 3000);
            }
        },
        mounted() {
            //converting the date format using this method converFilter
            this.date = this.convertFilter(this.date)
            this.formatted_date = this.date
            //this.loadOrganisationSettings();
            this.assigned_to = {
                user_id: this.loggedInUser.user_id,
                full_name: this.loggedInUser.full_name
            }
            this.assigned_by = {
                user_id: this.loggedInUser.user_id,
                full_name: this.loggedInUser.full_name
            }
            this.$forceUpdate()
            if(this.$route.params.id != 'new'){
                this.ajaxCallInProgress = true
                setTimeout(() => {
                    this.loadLeadDetails()
                }, 300);
            }
            else {
                if(localStorage.getItem("create_new_lead_company")){
                    let create_comany_lead = JSON.parse(localStorage.getItem("create_new_lead_company"))
                    this.lead_title = create_comany_lead.title
                    this.lead_first_name = create_comany_lead.first_name
                    if(create_comany_lead.territory.hasOwnProperty('id')){
                        this.territory = create_comany_lead.territory,
                        this.territory.id = create_comany_lead.territory_id
                    }
                    this.lead_middle_name = create_comany_lead.middle_name
                    this.lead_last_name = create_comany_lead.last_name
                    this.lead_email = create_comany_lead.lead_email.toLowerCase()
                    this.description = create_comany_lead.description,
                    this.formatted_date = create_comany_lead.lead_date
                    this.lead_type = create_comany_lead.lead_type == 'cold_lead' ? "Cold Lead" : create_comany_lead.lead_type == 'hot_lead' ? 'Hot Lead' : create_comany_lead.lead_type == 'warm_lead' ? 'Warm Lead' : null
                    if(create_comany_lead.qualifying_lead_template_id != ''){
                        this.selected_template_id = create_comany_lead.qualifying_lead_template_id
                        this.qualifying_lead = {
                            qualifying_lead_name: create_comany_lead.qualifying_lead_template_name
                        }
                    }
                    this.lead_user_phone = {
                        phone_number: create_comany_lead.lead_number.phone_number || '',
                        dial_code: create_comany_lead.lead_number.dial_code || '',
                        country_code: create_comany_lead.lead_number.country_code || '',
                        phone_type: create_comany_lead.lead_number.phone_type || ''
                    }
                    this.phone = {
                        number: create_comany_lead.lead_number.phone_number || '',
                        isValid: false,
                        country: {
                            dialCode: create_comany_lead.lead_number.dial_code || '',
                            iso2: create_comany_lead.lead_number.country_code || ''
                        }
                    }
                    if(create_comany_lead.campaign_source != ''){
                        this.campaign_source = {
                            value: create_comany_lead.campaign_source
                        }
                    }
                    this.assigned_by = {
                        user_id: create_comany_lead.assigned_by,
                        full_name: create_comany_lead.assigned_by_name
                    }
                    this.assigned_to = {
                        user_id: create_comany_lead.assigned_to,
                        full_name: create_comany_lead.assigned_to_name
                    }
                    this.industry_type = create_comany_lead.industry_type
                    this.company_name = create_comany_lead.company_name
                    this.company_email = create_comany_lead.company_email
                    //Lead conventional details//
                    if (create_comany_lead.lead_source == 'conventional') {
                        this.lead_source = 'Conventional'
                        this.location = {
                            street: create_comany_lead.location.street,
                            city: create_comany_lead.location.city,
                            township: create_comany_lead.location.township,
                            country: create_comany_lead.location.country,
                            zip_code: create_comany_lead.location.zip_code,
                            state:create_comany_lead.location.state,
                            latitude: create_comany_lead.location.latitude,
                            longitude: create_comany_lead.location.longitude
                        }
                        this.location_introduced =
                        (this.location.street ? this.location.street + ',' : '') +
                        (this.location.city ? this.location.city + ',' : '') +
                        (this.location.state ? this.location.state + ',' : '') +
                        (this.location.township ? this.location.township + ',' : '') +
                        (this.location.country ? this.location.country + ',' : '') +
                        (this.location.zip_code ? this.location.zip_code : '')
                        if(create_comany_lead.lead_contact_type.hasOwnProperty('value')){
                            this.lead_contact_type = {
                                value: create_comany_lead.lead_contact_type.value
                            }
                        }
                        this.meeting_type = create_comany_lead.meeting_type
                        this.referred_by = create_comany_lead.referred_by
                        this.secondary_attendes_type = []
                        create_comany_lead.secondary_attendes_type.forEach(x => {
                            this.secondary_attendes_type.push(x)
                        })
                        // setTimeout(() => {
                        //     this.store_attendees.forEach(x => {
                        //         this.secondary_attendes_type.push(x)
                        //     })
                        //     this.assign_loading = false
                        // }, 3000);
                    }  //Social Media details//
                    else if (create_comany_lead.lead_source == 'social_media') {
                        this.lead_source = 'Social Media'
                        this.social_media = []
                        this.social_media = create_comany_lead.social_media
                        // this.social_media.forEach((el,index)=> {
                        //     this.isURLValidFacebook(el.account_url,index)
                        // })
                }   }
            }
            if(this.loggedInUser.time_zone == 'Asia/Kolkata' ){
                this.lead_start_date = this.timeKolkata.toUTCString()
                this.lead_start_date = this.lead_start_date.toString()
            }
            else if(this.loggedInUser.time_zone == 'Europe/London'){
                this.lead_start_date = this.timeLondon
            }
            else if(this.loggedInUser.time_zone == 'America/New_York'){
                this.lead_start_date = this.timeNewYork
            }
            else if(this.loggedInUser.time_zone == 'Asia/Singapore'){
                this.lead_start_date = this.timeSingapore
            }
            else if(this.loggedInUser.time_zone == 'Asia/Yangon'){
                this.lead_start_date = this.timeYangon
            }
            this.$forceUpdate()

        },
        created() {
            //Added debounce for all search methods
            this.searchAssigned = debounce(this.searchAssignedDebouncer, 500)
            this.searchTerritory = debounce(this.searchTerritoryDebouncer, 500)
            this.SearchCampaignSource = debounce(this.SearchCampaignSourceDebouncer, 500)
            this.SearchContactedVia = debounce(this.SearchContactedViaBouncer, 500)
            this.searchMeetingType = debounce(this.searchMeetingTypeDebouncer, 500)
            this.SearchSocialMedia = debounce(this.SearchSocialMediaDebouncer, 500)
            this.loadQualifyingLeadList = debounce(this.loadQualifyingLeadListDebouncer, 500)
            //Added custom validation for required fields
            const dict = {
                custom: {
                    lead_first_name: {
                        required: () => "First Name is required",
                        regex: () => "Enter a Valid Name",
                    },
                    company_name: {
                        required: () => "Company Name is required",
                    },
                    company_email: {
                        required: () => "Company Email is required",
                        email: () => "Please Enter Valid Email Address",
                    },
                    lead_last_name: {
                        required: () => "Last Name is required",
                        regex: () => "Enter a Valid Name",
                    },

                    lead_user_phone: {
                        required: () => "Phone Number is required",
                        min: () => "Phone Number must contain more than 9 numbers",
                    },
                    lead_email: {
                        required: () => "Email Address is required",
                        email: () => "Please Enter Valid Email Address"
                    }

                }
            };
            this.$validator.localize("en", dict);
        },
        components: {
            DatePicker,
            leads,
            axios,
            globals,
            HalfCircleSpinner,
            SweetModal,
            SuccessMessage,
            HollowDotsSpinner,
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
             //adding the all fields data in create leads
            create_leads() {
                return {
                    dropdown_type : '',
                    assigned_to_company: this.selected_lead == 'Company' ? true : false,
                    is_automated: false,
                    title: this.lead_title,
                    first_name: this.lead_first_name,
                    middle_name: this.lead_middle_name,
                    last_name: this.lead_last_name,
                    lead_email: this.lead_email,
                    lead_date: this.formatted_date,
                    description: this.description,
                    lead_time: this.lead_start_time,
                    campaign_source: this.campaign_source ? this.campaign_source.value : '',
                    assigned_by: this.assigned_by.user_id,
                    assigned_by_name: this.assigned_by.full_name,
                    assigned_to: this.assigned_to.user_id,
                    assigned_to_name: this.assigned_to.full_name,
                    qualifying_lead_template_id: this.selected_template_id,
                    lead_type: this.lead_type == 'Cold Lead' ? "cold_lead" : this.lead_type == 'Hot Lead' ? 'hot_lead' : 'warm_lead',
                    lead_source: this.lead_source == "Social Media" ? 'social_media' : 'conventional',
                    lead_number: {
                        phone_type: "mobile",
                        phone_number: this.lead_user_phone ? this.lead_user_phone.phone_number : "",
                        country_code: this.lead_user_phone ? this.lead_user_phone.country_code : "",
                        dial_code: this.lead_user_phone ? this.lead_user_phone.dial_code : ""
                    },
                    territory_id: this.territory.id,
                }
            },
            switch_lead(){
                return {
                    company_name: this.company_name,
                    company_email: this.company_email,
                    industry_type: this.industry_type,
                    dropdown_type : '',
                    assigned_to_company: this.selected_lead == 'Company' ? true : false,
                    is_automated: false,
                    title: this.lead_title,
                    first_name: this.lead_first_name,
                    middle_name: this.lead_middle_name,
                    last_name: this.lead_last_name,
                    lead_email: this.lead_email,
                    lead_date: this.formatted_date,
                    description: this.description,
                    lead_time: this.lead_start_time,
                    campaign_source: this.campaign_source ? this.campaign_source.value : '',
                    assigned_by: this.assigned_by.user_id,
                    assigned_by_name: this.assigned_by.full_name,
                    assigned_to: this.assigned_to.user_id,
                    assigned_to_name: this.assigned_to.full_name,
                    qualifying_lead_template_id: this.selected_template_id,
                    qualifying_lead_template_name: this.qualifying_lead.qualifying_lead_name,
                    lead_type: this.lead_type == 'Cold Lead' ? "cold_lead" : this.lead_type == 'Hot Lead' ? 'hot_lead' : this.lead_type == 'Warm Lead' ? 'warm_lead' : '',
                    lead_source: this.lead_source == "Social Media" ? 'social_media' : 'conventional',
                    lead_number: {
                        phone_type: "mobile",
                        phone_number: this.lead_user_phone ? this.lead_user_phone.phone_number : "",
                        country_code: this.lead_user_phone ? this.lead_user_phone.country_code : "",
                        dial_code: this.lead_user_phone ? this.lead_user_phone.dial_code : ""
                    },
                    territory_id: this.territory.id,
                    territory: this.territory,
                    location_introduced: this.location_introduced,
                    lead_contact_type: this.lead_contact_type,
                    secondary_attendes_type: this.secondary_attendes_type,
                    referred_by: this.referred_by,
                    meeting_type: this.meeting_type,
                    location:{
                        street: this.location.street,
                        city: this.location.city,
                        township: this.location.township,
                        state: this.location.state,
                        country: this.location.country,
                        zip_code: this.location.zip_code,
                        latitude: this.location.latitude,
                        longitude: this.location.longitude
                    },
                    social_media: this.social_media,
                }
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
            fields_not_changed(){
                return this.stringified_response == JSON.stringify(this.create_leads)
            },
            conventional_data(){
                return {
                    location_introduced: this.location_introduced,
                    location:{
                        street: this.location.street,
                        city: this.location.city,
                        township: this.location.township,
                        state: this.location.state,
                        country: this.location.country,
                        zip_code: this.location.zip_code,
                        latitude: this.location.latitude,
                        longitude: this.location.longitude
                    },
                    lead_contact_type: this.lead_contact_type,
                    secondary_attendes_type: this.secondary_attendes_type,
                    referred_by: this.referred_by,
                    meeting_type: this.meeting_type,
                    social_media: this.social_media,
                }
            },
            con_fields_not_changed(){
                return this.con_stringified_response == JSON.stringify(this.conventional_data)
            },
        },
        beforeRouteLeave (to, from, next) {
            if(to.path != `/leads/createLeads/individual/new`){
                localStorage.removeItem("create_new_lead_company")
                localStorage.removeItem("create_new_lead_individual")
                next()
           } else {
                next()
            }
        },
    }
</script>


<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }

    .overflow-auto {
        overflow: auto;
    }


    .change-pic {
        position: absolute;
        bottom: -10px;
        width: 100%;
    }

    .edit-image {
        position: absolute;
        right: 0;
        bottom: 5px;
    }

    .change-cover-pic {
        padding: 3.5px 10px;
        border-radius: 50px;
        -webkit-backdrop-filter: blur(1.5px);
        backdrop-filter: blur(1.5px);
        background-color: rgba(114, 100, 100, 0.2);
        color: #fff;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }

    .input-field {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        font-size: 14px !important;
        font-weight: 600;
        color: #303031 !important;
    }

    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
        font-weight: 600;
    }

    .input-field-length {
        opacity: 0.5;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.3px;
        color: #000;
    }

    .btn-new-cancel {
        color: #d51650;
        background-color: #fff;
        border-radius: 5px;
        padding-left: 20px;
        padding-right: 20px;
        text-transform: none;
        font-weight: 600;
        border: 1px solid #d51650;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-cancel-disable {
        color: #d51650;
        background-color: #fff;
        border-radius: 5px;
        padding-left: 20px;
        padding-right: 20px;
        text-transform: none;
        font-weight: 600;
        line-height: 30px;
        box-shadow: none;
    }

    .btn-new-save {
        border: 2px solid #00448b;
        line-height: 30px;
        border-radius: 5px;
    }
    .btn-new-save-disabled {
        line-height: 30px;
        border-radius: 5px;
    }

    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }

    .mx-input {
        /* border-bottom: 1px solid #fff !important; */
        display: inline-block;
        height: 0px !important;
    }

    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }

    .secondary_row {
        width: 200px
    }

    .text-green {
        color: #448e4d !important;
    }

    .pointer-event {
        background-color: #fff !important;
    }
    .text-line {
        text-decoration :none !important;
    }
    .padding-right{
        padding-right: -10px !important;
    }
    .max-width{
        max-width: 350px !important;
    }
    @media screen and (max-width: 991px) {
		.margin-left-res {
            margin-left: 16px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Leads/EditLeads.vue